var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#056DA0;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 23,
    height: 23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    transform: "translate(-151 -16)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG_8_",
    transform: "translate(151 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55_8_",
    className: "st1",
    d: "M11.7,0C5.3,0,0,5.1,0,11.5c0,0,0,0.1,0,0.1c0,6.4,5.1,11.6,11.5,11.7c0,0,0.1,0,0.1,0 c6.4,0,11.6-5.1,11.7-11.5c0,0,0-0.1,0-0.1C23.4,5.3,18.2,0,11.8,0C11.8,0,11.7,0,11.7,0z M11.7,21.7c-5.5,0-10-4.5-10-10 s4.5-10,10-10s10,4.5,10,10C21.7,17.2,17.2,21.7,11.7,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56_8_",
    className: "st1",
    d: "M16.2,17.5L11.7,13l-4.5,4.5l-1.3-1.3l4.5-4.5L5.8,7.2l1.3-1.3l4.5,4.5l4.5-4.5l1.3,1.3 L13,11.7l4.5,4.5L16.2,17.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.edb3077a63ffb7c2f3d868471e444c89.svg";
export { ForwardRef as ReactComponent };